import apiClient from './client';

export const ActivityPreApprovalsAxiosInstance = apiClient;